import { render, staticRenderFns } from "./AwardsSetting.vue?vue&type=template&id=2fd6bb9b&"
import script from "./AwardsSetting.vue?vue&type=script&lang=js&"
export * from "./AwardsSetting.vue?vue&type=script&lang=js&"
import style0 from "./AwardsSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports